// Shared shape for the "Anchor your target reference" panel. The parent
// (CreateFlavorPage) owns one controlled `Anchor` object and computes
// readiness from it; AnchorPanel + its sub-modes are controlled by it.
// Mirrors the Claude Design prototype (create.jsx / anchor-target.jsx).

import type { Recommendation } from "@/utils/types/flavor";
import type { Chroma } from "@/utils/types/upload";
import type { FormulaImport } from "@/components/FormulationImport";

export type AnchorMode = "catalog" | "library" | "describe";
export type LibMode = "select" | "chroma" | "import";

export type Anchor = {
  mode: AnchorMode;
  // catalog
  pickedRec: Recommendation | null;
  // own-library sub-mode
  libMode: LibMode;
  // own-library: select
  libSearch: string;
  pickedLibId: string | null;
  // resolved substance ref for the picked library item — the actual TARGET the
  // create endpoint needs (a library item maps to a public.food | public.compound
  // row via its inventory child). null until something resolvable is picked.
  pickedLibRef: {
    ndbTable: "public.food" | "public.compound";
    rowId: number;
    name: string;
  } | null;
  // own-library: add new substance (chroma) / import — the name of the new entry
  newName: string;
  chromas: Chroma[];
  // per-file experiment-configuration assignment, keyed by chroma.fileUploadId →
  // user_exp_config_id (uuid). Lifted here (not ChromatogramMode-local) so the
  // submit can forward it as finalizeUploads `configs`.
  chromaConfigById: Record<string, string>;
  // own-library: import formulation
  formulaImport: FormulaImport | null;
};

export const EMPTY_ANCHOR: Anchor = {
  mode: "catalog",
  pickedRec: null,
  libMode: "select",
  libSearch: "",
  pickedLibId: null,
  pickedLibRef: null,
  newName: "",
  chromas: [],
  chromaConfigById: {},
  formulaImport: null,
};
